module.exports = __webpack_public_path__ + "static/2-a18ff2d29f65ec5b423b2fe541bdbf76.png";